<template>
<span class="menu-chip-container">
    <v-chip
        x-small
        :color="chip_color"
        :text-color="text_color"
        outlined
        class="menu-chip"
    >
        {{text}}
    </v-chip>
</span>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: function() { return 'new'; }
        },
    },

    computed: {
        chip_color() {
            let type = this.type.toLowerCase().trim();

            if (type === 'rc-staff') {
                return 'success';
            }

            return 'primary';
        },

        text_color() {
            return this.chip_color;
        },

        text() {
            let type = this.type.toLowerCase().trim();

            if (type === 'rc-staff') return 'Staff Only';
            return 'New';
        },
    },
}
</script>

<style lang="scss" scoped>
.menu-chip-container {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
}

.menu-chip {
    height: 16px !important;
    font-size: 9px !important;
    font-weight: 500 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    ::v-deep .v-chip__content {
        padding: 0 4px !important;
        line-height: 16px !important;
    }
}
</style>